module.exports = __webpack_public_path__ + "media/images/logo-icon-white-b234b63f1855b7503b1732ac23254d16.svg";